const VIEW_ACCESS_TEMPLATE = {
  lawfirm: {
    route: "/lawfirm",
    subRoute: "",
    permission: "lawyer.view_lawfirm",
  },
  entity: {
    route: "/entity",
    subRoute: "",
    permission: "users.view_entity",
  },
  provider: {
    route: "/provider",
    subRoute: "/location-info/hours-of-operation",
    permission: "provider.view_provider",
  },
  campaign: {
    route: "/campaign",
    subRoute: "",
    permission: "leads.view_all_campaigns",
  },
  case: {
    route: "/client-detail",
    subRoute: "",
    permission: "casemanager.view_case",
  },
};

export default VIEW_ACCESS_TEMPLATE;
